export class CbPaginationModel {
  public page: number;
  public collectionSize: number;
  public pageSize: number;
  public maxSize: number;

  constructor() {
    this.page = 1;
    this.collectionSize = 0;
    this.pageSize = 5;
    this.maxSize = 5;
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/display/cb-pagination/cb-pagination-model.ts